"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ServerError = exports.PbError = void 0;
/** Generic Owner error */
class PbError extends Error {
    isPbError = true;
    name = 'PbError';
    context;
    /**
     * Throws a PbError
     *
     * @param message The error message
     * @param context Error payload
     * @param opts Error options
     * @param opts.override Set to true if you want to catch other PbErrors
     */
    constructor(message, context, { override = false } = {}) {
        super(message);
        if (!override && context?.isPbError)
            throw context;
        this.context = context;
        // This method is only available in NodeJS
        if (Error.captureStackTrace) {
            Error.captureStackTrace(this, PbError);
        }
    }
}
exports.PbError = PbError;
/** Any error originating server-side */
class ServerError extends PbError {
    displayToClient = false;
    name = 'ServerError';
    status = 500;
    details = null;
    headers;
    /**
     *
     * @param status An HTTP status code
     * @param message The message for the
     * @param context deprecated: error context (use opts.details instead)
     * @param opts An options object
     * @param opts.displayToClient Set to true if the server-originated error should be displayed to the client
     * @param opts.details Typed error details
     * @param opts.override Set to true if you want to catch PbErrors
     * @param opts.headers Headers to include in the response
     */
    constructor(status, message, context, { displayToClient = false, override = false, details = null, headers = {}, } = {}) {
        super(message, context, { override });
        this.status = status;
        this.details = details;
        this.displayToClient = displayToClient;
        this.headers = headers;
    }
}
exports.ServerError = ServerError;
//# sourceMappingURL=index.js.map